import { module } from 'angular';

import { IBuildInfo } from 'core/domain';

export function buildDisplayName(input: IBuildInfo): string {
  if (!input) {
    return '';
  }
  let formattedInput = '';
  if (input.fullDisplayName !== undefined) {
    formattedInput = input.fullDisplayName.split('#' + input.number).pop();
  }
  return formattedInput;
}

export function buildDisplayNameFilter() {
  return buildDisplayName;
}

export const BUILD_DISPLAY_NAME_FILTER = 'spinnaker.core.pipeline.buildDisplayName.filter';
module(BUILD_DISPLAY_NAME_FILTER, [])
  .filter('buildDisplayName', buildDisplayNameFilter);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/pipeline/executionBuild/buildDisplayName.filter.ts